import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Header from "../layouts/Header";
import Sidebar from "../layouts/Sidebar";
// import { useFormik } from "formik";
// import * as Yup from "yup";
import axios from "../api/axios";
import FindModuleById from '.././FindModuleById';
import {  Apitoken, Authtoken  } from "../Global";
// import $ from "jquery";
import Swal from 'sweetalert2';
import {
  // Box,
  // Button,
  // ListItemIcon,
  MenuItem,
  // Typography,
  // TextField,
} from '@mui/material';
import {MaterialReactTable} from 'material-react-table';

// import { AccountCircle, Send } from '@mui/icons-material';
// //import Button from '@mui/material/Button';
// import ButtonGroup from '@mui/material/ButtonGroup';
// import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
// import ClickAwayListener from '@mui/material/ClickAwayListener';
// import Grow from '@mui/material/Grow';
// import Paper from '@mui/material/Paper';
// import Popper from '@mui/material/Popper';
// //import MenuItem from '@mui/material/MenuItem';
// import MenuList from '@mui/material/MenuList';
// import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ProductListingGroupBY = () => {
  let { id } = useParams();
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([]);


  const [permission, setPermission] = useState({});

  useEffect(() => {
        setPermission(FindModuleById(5)); 
console.log(permission);

   
    axios
      .get(`/products/listing-products/${id}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setData(response.data.data.products);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [id]);

 

  
  // const viewItem = (item)=>{
  //   window.location.href = "/products-view/"+item;

  // }

  const editItem = (item)=>{
    window.location.href = "/products-edit/"+item;
  }


  const columns =
  [
    {
      accessorKey: 'code', //normal accessorKey
      header: 'Product ID',
    },
    {
      accessorKey: 'name', //normal accessorKey
      header: 'Product Name',
    },
     {
      header: 'Category',
      accessorFn: (row) => `${(row.category)?row.category.title:""} `,
    },
    {
      header: 'Type',
      accessorFn: (row) => `${(row.type)?row.type.title:""} `,
    },
   

    {
      accessorKey: 'description', //normal accessorKey
      header: 'Description',
    },
    // {
    //   header: 'Created By',
    //   accessorFn: (row) => `${(row.createdby)?row.createdby.first_name+ ' '+ row.createdby.last_name:""} `,
    // },
    // {
    //   header: 'Updated By',
    //   accessorFn: (row) => `${(row.updatedby)?row.updatedby.first_name+ ' '+ row.updatedby.last_name:""} `,
    // },
   ];
   const toggleMobileMenu = () => {
    setMenu(!menu);
  };
   const deleteItem = (item) => {
      Swal.fire({
        title: 'Do you really want to delete this record?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'DELETE'
      }).then((result) => {
        if (result.isConfirmed) {
          axios.get(`/products/delete/${item}`, {
                headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
              })
              .then((response) => {
                console.log(response);
                if (response.data.code === 200) {
                  Swal.fire(
                    'Deleted!',
                    'Your Record has been deleted.',
                    'success'
                  );
                  setTimeout(() => {
                    window.location.href = "/products";
                  }, 500);
                }
              })
              .catch((error) => {
                console.log(error);
              });
        }
      });
    }
  return (
    <>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar /> 
         {/* <ToastContainer /> */}
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Products Listing Group By Product Name</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/profile">Profile</Link>
                    </li>
                    <li className="breadcrumb-item">
                      <Link to="/products">Products</Link>
                    </li>
                    <li className="breadcrumb-item active">Products Listing Group By Product Name</li>
                  </ul>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    {permission && permission.list == 1 && (
                      <div className="table-responsive">

                        <MaterialReactTable columns={columns} data={data} 
                            enableColumnOrdering
                            enablePinning
                            enableRowActions
                            //renderColumnActionsMenuItems 
                            // renderRowActionMenuItems={({ row }) => (
                            //   <div>
                            //     {permission && permission.update == 1 && (
                            //       <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                            //         Edit
                            //       </MenuItem>
                            //     )}
                            //     {permission && permission.delete === 1 && (
                            //       <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                            //         Delete
                            //       </MenuItem>
                            //     )}
                            //   </div>
                            // )}
                             
                        renderRowActionMenuItems={({ row }) => [
                          permission?.update == 1 && (
                            <MenuItem key="edit" onClick={() => editItem(row.original.id)}>
                              Edit
                            </MenuItem>
                          ),
                          permission?.delete == 1 && (
                            <MenuItem key="delete" onClick={() => deleteItem(row.original.id)}>
                              Delete
                            </MenuItem>
                          ),
                        ]}
                          />    
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default ProductListingGroupBY;
